import { useAppSelector } from "state/hooks.ts";
import { getDepositFundsModalState } from "state/slices/deposit-funds-modal-v2-slice.ts";
import { getPaynoteFundingSourcesState } from "state/slices/paynote-funding-sources-slice.ts";
import { getPaymentMethodsState } from "state/slices/user-payment-methods-slice.ts";
import PaymentNote from "./payment-note.tsx";

const DepositNote = () => {
  const modalState = useAppSelector(getDepositFundsModalState);
  const fundingSourcesState = useAppSelector(getPaynoteFundingSourcesState);
  const paymentMethodsState = useAppSelector(getPaymentMethodsState);

  const { processing, selectedPaymentMethod } = modalState;

  // Transform selected payment method for the generic PaymentNote component
  const transformedPaymentMethod = selectedPaymentMethod ? {
    type: selectedPaymentMethod.type,
    paynoteFundingSourceId: selectedPaymentMethod.type === 'ACH' ? selectedPaymentMethod.paynoteFundingSourceId : undefined,
    inovioUserPaymentMethodId: selectedPaymentMethod.type === 'CARD' ? selectedPaymentMethod.inovioUserPaymentMethodId : undefined,
    bankName: selectedPaymentMethod.type === 'ACH' ? 
      fundingSourcesState.fundingSources.find(s => s.id === selectedPaymentMethod.paynoteFundingSourceId)?.bankName : 
      undefined,
    last4: selectedPaymentMethod.type === 'ACH' ? 
      fundingSourcesState.fundingSources.find(s => s.id === selectedPaymentMethod.paynoteFundingSourceId)?.last4 :
      selectedPaymentMethod.type === 'CARD' && selectedPaymentMethod.inovioUserPaymentMethodId !== 'NEW' ?
        paymentMethodsState.items.find(m => m.id === selectedPaymentMethod.inovioUserPaymentMethodId)?.last4 :
        undefined
  } : undefined;

  return (
    <PaymentNote
      processing={processing}
      paymentMethod={transformedPaymentMethod}
      actionType="deposit"
    />
  );
};

export default DepositNote; 